





















































































































import BaseComponent from '@/components/base-component.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectGeoAreas from '@/components/UI/select-geo-area.vue';
import UiSelectSortOptions from '@/components/UI/select-sort-options.vue';
import {
  institutionSyncGeoAreas,
  listInstitutionContactsCombo,
  listInstitutionVisitContactsCombo,
  listInstitutionVisitorsCombo
} from '@/services/crm-institution';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiFilterContainer,
    UiSelectSortOptions,
    UiSelectGeoAreas
  }
})
export default class InstitutionFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  @Prop()
  public reloadCount: number;

  filter: any = {};

  descending = false;
  sortBy = 'nomeFantasia';
  sortOptions = [];

  semVisitaOpcoes = [
    { id: -1, label: 'Nenhuma visita' },
    { id: 7, label: '7 dias ou mais' },
    { id: 15, label: '15 dias ou mais' },
    { id: 30, label: '30 dias ou mais' },
    { id: 60, label: '60 dias ou mais' },
    { id: 90, label: '90 dias ou mais' },
    { id: 180, label: '6 meses ou mais' },
    { id: 365, label: '1 ano ou mais' },
    { id: 730, label: '2 anos ou mais' },
    { id: 1095, label: '3 anos ou mais' }
  ];

  visitors = [];
  institutionContacts = [];
  visitContacts = [];

  mounted() {
    this.buildSortOptions();
    this.loadCombos();
  }

  buildSortOptions() {
    this.descending = false;
    this.sortBy = 'nomeFantasia';
    this.sortOptions = [];
    this.sortOptions.push({ text: 'Ciente/Prospect', value: 'prospect' });
    this.sortOptions.push({ text: 'CNPJ', value: 'cnpj' });
    this.sortOptions.push({ text: 'Nome Fantasia', value: 'nomeFantasia' });
    this.sortOptions.push({ text: 'Status', value: 'status' });
    this.sortOptions.push({ text: 'Ultima visita', value: 'ultimaVisita' });
    this.sortOptions.push({ text: 'Próxima visita', value: 'proximaVisita' });
    this.sortOptions.push({ text: 'Dias sem visita', value: 'diasSemVisitaOrdenar' });
  }

  onSortChange(by, desc) {
    this.sortBy = by;
    this.descending = desc;
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.filter.oldTextoBusca = this.filter.textoBusca;
    this.emitFilter();
  }

  emitFilter() {
    if (this.menuMode) {
      this.filter.descending = this.descending;
      this.filter.sortBy = this.sortBy;
    } else {
      this.filter.sortBy = null;
    }
    this.$emit('filter', this.filter);
  }

  @Watch('reloadCount')
  onReloadCountChange() {
    this.loadCombos();
  }

  loadCombos() {
    listInstitutionVisitorsCombo().subscribe((res) => {
      this.visitors = res;
    });
    listInstitutionContactsCombo().subscribe((res) => {
      this.institutionContacts = res;
    });
    listInstitutionVisitContactsCombo().subscribe((res) => {
      this.visitContacts = res;
    });
  }

  syncGeoAreaLoading = false;
  syncGeoArea() {
    this.syncGeoAreaLoading = true;
    institutionSyncGeoAreas().subscribe(
      (res) => {
        this.syncGeoAreaLoading = false;
        this.toast.show(res, 'success');
        this.emitFilter();
      },
      (error) => {
        this.showToastApiError(error);
        this.syncGeoAreaLoading = false;
      }
    );
  }
}
